import { sendFetch, GET_OPTIONS } from './base.service';

const BASE_PATH = '/departments';

export const findAllDepartments = async () => {
    return await sendFetch(`${BASE_PATH}/all`, GET_OPTIONS);
}